import { Button, ButtonProps } from '@cdl/heartbeat-react';
import React, { PropsWithChildren, useState } from 'react';

type Props = PropsWithChildren<{
  onClick: () => void;
  dataTestId: string;
  disabled?: boolean;
}> &
  ButtonProps;

export const CustomButton: React.FC<Props & React.CSSProperties> = ({
  disabled = false,
  onClick,
  children,
  dataTestId,
  size = 'xs',
  ...props
}) => {
  const [waiting, setWaiting] = useState(false);
  const clicked = async () => {
    setWaiting(true);
    await onClick();
    setWaiting(false);
  };
  return (
    <Button
      size={size}
      data-testid={dataTestId}
      isDisabled={disabled}
      isLoading={waiting}
      onClick={clicked}
      {...props}
    >
      {children}
    </Button>
  );
};
